import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Chip, Stack, Typography } from '@mui/material';

import EPUserPicker from './EPUserPicker';
import type { EPSmsContentProps } from './EscalationProfile.types';

const EPSmsContent = ({
  priority,
  isEditing,
  smsUsers,
  availableUsers,
  selectedUser,
  setSelectedUser,
  onAddUser,
  onRemoveUser
}: EPSmsContentProps) => {
  return (
    <Stack spacing={1}>
      <Typography sx={{ fontWeight: 'bold' }}>Notify via SMS</Typography>
      {isEditing ? (
        <>
          <EPUserPicker
            options={availableUsers}
            value={selectedUser}
            onChange={setSelectedUser}
            getOptionDisabled={(u) => !u.phone_number || !u.sms_consent}
            renderOptionSubtitle={(u) => (
              <Stack direction="row" sx={{ alignItems: 'center' }} spacing={1}>
                <Typography
                  variant="caption"
                  color={u.phone_number ? 'text.secondary' : 'warning'}
                >
                  {u.phone_number ?? 'No phone number'}
                </Typography>
                {!u.sms_consent && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ marginLeft: 1 }}
                  >
                    No consent
                  </Typography>
                )}
              </Stack>
            )}
            onAdd={onAddUser}
          />
          {smsUsers.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              No users configured
            </Typography>
          ) : (
            <Stack sx={{ flexDirection: 'row', flexWrap: 'wrap', gap: 1 }}>
              {smsUsers.map((u) => (
                <Chip
                  key={u.id}
                  label={u.name + (!u.sms_consent ? ` (no consent)` : '')}
                  size="small"
                  onDelete={() => onRemoveUser(u.id)}
                  color={!u.sms_consent ? 'error' : 'default'}
                  deleteIcon={
                    <FontAwesomeIcon
                      icon={faTimesCircle}
                      style={{ fontSize: '0.65rem' }}
                    />
                  }
                />
              ))}
            </Stack>
          )}
        </>
      ) : smsUsers.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No users configured for P{priority} SMS notifications
        </Typography>
      ) : (
        <Stack sx={{ flexDirection: 'row', flexWrap: 'wrap', gap: 1 }}>
          {smsUsers.map((u) => (
            <Chip
              key={u.id}
              label={u.name + (!u.sms_consent ? ` (no consent)` : '')}
              size="small"
              color={!u.sms_consent ? 'error' : 'default'}
            />
          ))}
        </Stack>
      )}
    </Stack>
  );
};

export default EPSmsContent;
